export default "__VITE_ASSET__2VzMIAyz__"